import React from 'react';
import { withStyles } from '@material-ui/core';

const styles = (theme) => ({
  title: {
    display: 'flex',
    width: '100%',
    fontSize: theme.font.size50,
    fontWeight: "normal",
    fontWeight: 'bold', 
    justifyContent: 'center'
 }
});

function Error(props) {
  const { classes } = props;
  return (
    <>
      <div className={classes.title}>
        404 Not Found
      </div> 
    </>
  );
}
export default withStyles(styles)(Error);